var a;!function(a){a.domain="https://www.magazineluiza.com.br"}(a||(a={}));export{a as Constants};
